module.exports = __webpack_public_path__ + "static/media/arrow_previous_blue.1ca2ddb3.svg";